export default __webpack_public_path__ + "static/media/image2.9fd4cf93.jpg";